import * as React from 'react';
import { Await, useRouteLoaderData } from 'react-router-dom';
import { CopilotStartPage } from './copilot/copilot';
import { AgencyUserFieldsFragment } from '../api/graphql';

export const HomePage = () => {
  const loader = useRouteLoaderData('app') as
    | {
        data: Promise<{
          agencyUser: AgencyUserFieldsFragment;
        }>;
      }
    | undefined;

  return (
    <React.Suspense fallback={null}>
      <Await resolve={loader?.data}>
        {(data) => data?.agencyUser && <CopilotStartPage agencyUser={data.agencyUser} />}
      </Await>
    </React.Suspense>
  );
};
